import {
  DiscountGroup,
  MgSupplierItemSearchResultDTO,
  ProductGroupCount,
} from '@retail/products/types';
import { PaginationResultDTO } from '@shared/fetch-utils';
import { useItemSearch } from './useItemSearch';
import { useFetchBk04ProductGroupsForSupplier } from '@retail/products/data-access';
import { useFetchDiscountGroups } from '@retail/calculus/data-access';

interface Props {
  supplierNumber: number;
  selectedProductGroup?: boolean;
  selectedDiscountGroup?: boolean;
  selectedMgItemNumber?: number;
  itemSearch?: string;
  onItemSearchSuccess?: (result: PaginationResultDTO<MgSupplierItemSearchResultDTO[]>) => void;
  onItemSearchError?: (error: any) => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const useFetchSelectedLevelOptions = ({
  supplierNumber,
  selectedProductGroup,
  selectedDiscountGroup,
  selectedMgItemNumber,
  itemSearch = '',
  onItemSearchSuccess = noop,
  onItemSearchError = noop,
}: Props) => {
  const { data: productGroupsDto = [] } = useFetchBk04ProductGroupsForSupplier(
    { suspense: true, enabled: !!selectedProductGroup },
    { supplierId: supplierNumber }
  );

  const productGroups = productGroupsDto.map(ProductGroupCount.fromDto);
  const flattenedProductGroups = ProductGroupCount.flatten(productGroups);

  const { data: discountGroupsDto = [] } = useFetchDiscountGroups(
    { supplierId: supplierNumber },
    { suspense: true, enabled: !!selectedDiscountGroup }
  );
  const discountGroups = discountGroupsDto
    .map((discountGroup) => DiscountGroup.fromDto(discountGroup))
    .sort((a, b) => a.code.localeCompare(b.code));

  const { mgSupplierItems, isLoadingFetchItems, isLoadingMgItem, errorLoadingMgItem, mgItem } =
    useItemSearch({
      supplierId: supplierNumber,
      selectedMgItemNumber,
      itemSearch,
      onItemSearchSuccess,
      onItemSearchError,
    });

  return {
    productGroups,
    flattenedProductGroups,
    discountGroups,
    mgSupplierItems,
    isLoadingFetchItems,
    isLoadingMgItem,
    errorLoadingMgItem,
    mgItem,
  };
};
